export const beforeDragCreate = (event) => event?.source?.viewPreset?.id === "hourAndDay" ? true : false;